import PromoCodeComponent from './PromoCodeComponent';
import PromoCodeConstructor from './PromoCodeConstructor';

export default {
  PromoCodeComponent,
  PromoCodeConstructor,
};
